import { render, staticRenderFns } from "./CambioPassword.vue?vue&type=template&id=0c7712fe&scoped=true"
import script from "./CambioPassword.vue?vue&type=script&lang=ts"
export * from "./CambioPassword.vue?vue&type=script&lang=ts"
import style0 from "./CambioPassword.vue?vue&type=style&index=0&id=0c7712fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7712fe",
  null
  
)

export default component.exports